import simpleModal from "./simpleModal";

export default (videoUrl = '', modalHeader = '') => {
    // It's a bit scetchy but all we can do is to slightly replace the view.
    //https://us02web.zoom.us/rec/play/some_id to https://us02web.zoom.us/rec/download/some_id
    const url = videoUrl.replace('play', 'download')
    const modal = new simpleModal({
        id: 'zoom-video',
        content: '<video width="640" height="360" controls autoplay><source src="' + url + '" type="video/mp4"> </video>',
        header: modalHeader
    })
    modal.show()
}
